// Quante notifiche sono da leggere, per il pallino del menu: si chiede ogni minuto e si azzera
// quando si apre la pagina Notifiche.
import { useEffect, useState } from 'react';
import { api } from '../../lib/api';

const listeners = new Set<(n: number) => void>();
export const noteUnread = (n: number) => listeners.forEach((l) => l(n));

export function useUnread(): number {
  const [n, setN] = useState(0);
  useEffect(() => {
    listeners.add(setN);
    const ask = () =>
      void api.notifications().then(
        (r) => setN(r.unread),
        () => undefined,
      );
    ask();
    const t = window.setInterval(ask, 60_000);
    return () => {
      listeners.delete(setN);
      window.clearInterval(t);
    };
  }, []);
  return n;
}
